import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';
import { getThemeTokens, shellMetrics } from '../tokens';

export const styledBackstageSidebar = (
  theme: Theme,
): BackstageOverrides['BackstageSidebar'] => {
  const tokens = getThemeTokens(theme);

  return {
    drawer: {
      '& a, & li, & ul, & ol': {
        listStyle: 'none',
      },
      '& hr, & [class*="BackstageSidebarDivider-root"]': {
        backgroundColor: tokens.navigationBorder,
        border: 0,
        display: 'block',
        height: 1,
        margin: `${shellMetrics.railDividerGap}px ${shellMetrics.railOpenInset}px`,
        width: `calc(100% - ${shellMetrics.railOpenInset * 2}px)`,
      },
      '& ul, & ol': {
        margin: 0,
        padding: 0,
      },
      backgroundColor: theme.palette.navigation.background,
      borderRight: `1px solid ${tokens.navigationBorder}`,
      boxShadow: 'none',
      overflowX: 'hidden',
      width: shellMetrics.railClosedWidth,
    },
    drawerOpen: {
      '& a, & li, & ul, & ol': {
        listStyle: 'none',
      },
      '& hr, & [class*="BackstageSidebarDivider-root"]': {
        backgroundColor: tokens.navigationBorder,
        border: 0,
        display: 'block',
        height: 1,
        margin: `${shellMetrics.railDividerGap}px ${shellMetrics.railOpenInset}px`,
        width: `calc(100% - ${shellMetrics.railOpenInset * 2}px)`,
      },
      '& ul, & ol': {
        margin: 0,
        padding: 0,
      },
      backgroundColor: theme.palette.navigation.background,
      borderRight: `1px solid ${tokens.navigationBorder}`,
      boxShadow: 'none',
      overflowX: 'hidden',
      width: shellMetrics.railOpenWidth,
    },
  };
};
